var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visualizer"},[_c('v-btn',{attrs:{"x-small":""},on:{"click":function($event){return _vm.fit()}}},[_vm._v("fit")]),_c('div',{attrs:{"id":"mygraph2d"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }